import validate from "/usr/src/app/content/n3-treatments-2e12b72c-b23f-4346-9bf3-c336be2b40b1/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-2e12b72c-b23f-4346-9bf3-c336be2b40b1/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}